<template>
  <div id="app"  >
<!--    <div style="position: fixed; top: 500px; left: 1780px; height: 192px; width: 66px; background-color: red;"></div>-->
    <div class="fixed-element">
      <div v-if="showIcon"><img @click="openDialog" style="height: 64px;width: 64px;" src="./assets/img/compress.jpg"></div>
      <div ><img @click="toContact" style="height: 64px;width: 64px;" src="./assets/img/right1.jpg"></div>
      <div  @click="questionNaire"><img style="height: 64px;width: 64px;" src="./assets/img/right-ico2.png"></div>
      <div ><img @click="scrollToTop" style="height: 64px;width: 64px;" src="./assets/img/right-ico3.png"></div>
      <!-- <div ><img  @click="changeLanguage" style="height: 54px;width: 54px;padding: 10px" src="./assets/img/lang1.png"></div> -->


    </div>
<div class="box1" style=""  >
    <el-container >
<!--      <div  v-if="isScrolled9">-->
<!--      <Header/>-->
<!--      </div>-->

      <el-main>
        <router-view @my-event="showCompressIcon" @my-event2="closeCompressIcon"/>
        <!-- <LoginDialog ref="loginDialog" @user-updated="updateUser"></LoginDialog> -->
      </el-main>
      <!-- {{ user }}
      {{isLogin}} -->
    </el-container>
</div>
    <!-- 问卷--弹窗 -->
    <div v-if="open" class="Questionnaire-box target-box" style="display: block;">
        <div class="taget-close" @click="open=false"></div>
        <div class="box">
            <div class="close" @click="open=false"><img src="https://www.yasubit.com/template/pc/skin/images/icon13.png" alt=""></div>
            <div class="img"><img src="https://www.yasubit.com/template/pc/skin/images/img3.png" alt=""></div>
            <div class="tbox">
                <div class="t1">填问卷，免费领奖励</div>
                <div class="t2">
                    小Y检测到您已经在页面停留很久了，是不是对我们很感兴趣呢？
                    <br>花一分钟帮助我们了解您使用YASUBIT的感受吧。
                </div>
                <div class="t3">
                    <a href="/#/Guest" @click="open=false">填问卷，领奖励</a>
                    <!-- <router-link to="/Guest/" @click="open=false">请联系我们获取API/SDK</router-link> -->
                    <div @click="open=false" class="close2">算了</div>
                </div>
            </div>
        </div>
    </div>

    <div>
  </div>
  </div>

  
</template>

<script>
import LoginDialog from "./views/loginFront.vue";
import Cookies from "js-cookie";
import contact from "@/views/contact.vue";
import Home from "@/views/Home.vue";
import Header from "@/views/header.vue";
import EventBus from '@/assets/js/event-bus.js';
export default {
  components: {
    Header,
    LoginDialog,
  },
  mounted() {
    // 计时器，超过六十秒弹出弹窗
    this.timer = setInterval(() => {
      this.stayTime += 1;
      if (this.stayTime >= 60 * 5) {
        clearInterval(this.timer);
        this.open = true;
      }
    }, 1000);


    // 监听滚动事件
    // window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.handleScroll1);
    // 初始化时检查滚动位置
    this.handleScroll();
    // console.log(localStorage.getItem("loginToken"))
    this.token=localStorage.getItem("loginToken")
    // console.log(JSON.parse(localStorage.getItem("loginStatus")));
  // 从localStorage中获取保存的数据
    if(JSON.parse(localStorage.getItem("loginStatus"))){
      //已登录
      this.isShow1=false
      this.isShow2=true

      this.getUserInfo()




    }else {
//未登录
      this.isShow1=true

      this.isShow2=false
    }





    // this.fetchData()


  },
  created() {


    // if (Cookies.get("user")) {
    //   this.isLogin = true;
    //   const userData = Cookies.get("user");
    //   this.user = JSON.parse(userData);
    // }

      // 当页面不是首页的时候，隐藏侧边栏的图片压缩图标
      this.$router.beforeEach((to, from, next) => {
      if (to.name !== "home") {
        this.showIcon = false;
      }
      next();
    });
  },
  data() {
    return {
      isScrolled: true,
      username:'',
      token:'',
      id:0,
      data:[],
      data1:[],
      router: true,
      defaultActive: "/",
      isShow: false,
      isShow1:  false,
      isShow2:  false,
      user: {},
      isLogin: false,
      showIcon: false, //是否显示侧边栏图片压缩
      stayTime: 0, // 计时器，超过一定时间弹出弹窗询问用户
      timer: null,
      open: false,
    };
  },
  computed: {
    // 计算属性用于对数据进行排序
    sortedData: function () {
      return this.data.slice().sort((a, b) => a.sortOrder - b.sortOrder);
    }
  },

  methods: {
    handleScroll1() {

      const scrollDistance = window.scrollY || document.documentElement.scrollTop;

      // 当滚动距离小于等于500px时，设置isScrolled为true
      this.isScrolled = scrollDistance <=200;
    },
    goIndex(){
      this.$router.push({path:"/"})
    },
    beforeDestroy() {
      clearInterval(this.timer); // 组件销毁时清除计时器
    },

    getUserInfo(){

      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = { 'Authorization': `Bearer ${this.token}`     };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/users/info', { headers })
          .then(response => {
            // 请求成功时更新数据
            console.log('成功登录')
            this.username=response.data.data.username
            console.log(response.data.data.username)

          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });



    },
    exit(){
      console.log(333)
      this.isShow1=true
      this.isShow2=false

      localStorage.setItem("loginStatus",    JSON.stringify(this.isShow2));
      console.log(JSON.parse(localStorage.getItem("loginStatus")));

    },
    handleDropdownItemClick(childItem) {
      // 处理 <el-dropdown-item> 被点击的逻辑
      console.log('Dropdown item clicked:', childItem);
      // 添加其他逻辑...
      // if(childItem.parentId===3&&childItem.position==="1"){
      //   this.$router.push({path:"Technology"})
      // }
      if(childItem.id===65){
        this.$router.push({path:"FAQ"})
      }
      if(childItem.id===3){
        this.$router.push({path:"Technology"})
      }
      if(childItem.id===67){
        this.$router.push({path:"contact"})
      }

      if(childItem.newCategory===1){
        this.id=childItem.id
        sessionStorage.setItem('a', this.id);
        this.$router.push({
          name: 'templete2', // 使用路由的 name 属性

          params: { a: this.id }
        });
      }



    },
    handleMenuItemClick(item) {
      // 处理 <el-menu-item> 被点击的逻辑
      console.log('Menu item clicked:', item);

      // 添加其他逻辑...
      if(item.id===91){

      this.$router.push({path:"/"})

      }
      if(item.id===145){

        this.$router.push({path:"news"})

      }
      if(item.id===9){

        this.$router.push({path:"case"})

      }

      if(item.id===1){

        this.$router.replace({path:"about"})

      }


    },

    fetchData() {
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/website/list', { headers })
          .then(response => {
            // 请求成功时更新数据
            console.log(1111111111);
            this.data = response.data.data.position1;
            this.data1 = response.data.data.position3;
            console.log(this.data)
            console.log("底部")
            console.log(this.data1)
          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });
      // // 发送 GET 请求
      // this.$http.get('/system/user/deptTree')
      //     .then(response => {
      //       // 请求成功时更新数据
      //       console.log(1111111111)
      //       // this.data = response.data;
      //     })
      //     .catch(error => {
      //       // 请求失败时处理错误
      //       console.error('Error fetching data:', error);
      //     });
    },


    questionNaire(){

      this.$router.push({path:"/Guest"})

    },
    toContact(){
      this.$router.push({path:"contact"})




    },
    scrollToTop() {
      // 使用原生JavaScript滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 添加平滑滚动效果，如果不需要可以移除这一行
      });
    },
    changeLanguage() {
      // 切换为英语

    },
    openLoginDialog() {
      this.$refs.loginDialog.showLoginDialog();
    },
    login(){

      this.$router.push( {path:'Login'})


    },
    handleLoginSuccess(res) {
      console.log('Login Success! Code: ' + res.code);
      // 在这里可以将 res.code 发送到后端进行进一步处理
    },
    getWeiXinCode(){

      // 在mounted生命周期钩子中动态添加script标签引入wxLogin.js
      const script = document.createElement('script');
      script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
      script.async = true;
      document.head.appendChild(script);

      // 实例化WxLogin对象
      this.wxLoginObj = new WxLogin({
        self_redirect: true,
        id: 'login_container',
        appid: 'wx1d9a459294b117e7',
        // appid: 'wxf094fc7360e2b164',
        scope: 'snsapi_login',
        // redirect_uri: encodeURIComponent('https://www.yasubit.com'),
        redirect_uri: 'http%3A%2F%2Flocalhost%3A8080%2Fyasubit%2Fusers%2Fwechat%2Fcallback',
        state: 'STATE',
        style: '',
        href: '',

      });

      // 在 setTimeout 中添加事件监听
      setTimeout(() => {
        this.$refs.loginContainer.addEventListener('loginSuccess', this.handleLoginSuccess);
      }, 1000); // 假设 1000 毫秒足够等待脚本加载完成


    },

    handleCommand(command) {
      if (command === "a") {
        this.$router.push({ path: "technology" });
      }
      if (command === "b") {
        this.$router.push({ path: "FAQ" });
      }
      if (command === "c") {
        this.$router.push({ path: "about" });
      }
      if (command === "d") {
        this.$router.push({ path: "contact" });
      }
    },

    technicalIntroduction() {
      console.log(999999);
      window.console.log(5555);
    },

    handleSelect(key) {
      this.isShow = this.defaultActive !== key;
      window.console.log(this.isShow);
    },


    updateUser(newUser) {
      const userData = JSON.stringify(newUser);
      Cookies.set("user", userData, { expires: 30 });
      this.user = newUser;
      this.isLogin = true;
    },
    // home.vue点击最小化，图片压缩弹窗缩小到侧边栏
    showCompressIcon() {
      this.showIcon = true;
    },
    // home.vue点击关闭，侧边栏图片压缩也关闭
    closeCompressIcon() {
      this.showIcon = false;
    },
    // 点击侧边栏图片压缩，home.vue打开弹窗
    openDialog() {
      EventBus.$emit('openDialog');
    },
    

  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  overflow-x: hidden;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.box1 {
width: 100%;

  //
  //background-image: url('../src/assets/img/shouyebag.png'); /* 替换 'your-image.jpg' 为你的背景图片路径 */
  ////background-size: auto 50%; /* 背景图片宽度自适应，高度占据50% */
  //background-repeat: no-repeat;

}

/* 默认情况下，显示文字，隐藏图片 */
.box2 .logo div {
  display: inline-block;
}


.box2{

}

.box2  div {

  //color: #ffffff;
}
.box2:hover  div {
  color: #000000;
}


.box2 .logo img {
  display: none;
}

/* 鼠标悬停时，显示图片，隐藏文字 */
.box2:hover .logo img {
  display: inline-block;
}

/* 鼠标悬停时，背景色设为白色 */
.box2:hover {
  background-color: #ffffff;

}

/* 鼠标悬停时，隐藏文字 */
.box2:hover .logo div {
  display: none;
}


.fixed-element {
  background-color: white;
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 66px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
  //background-color: red;
  z-index: 1; /* 设置一个较大的 z-index 值 */
}

.fixed-element > div {
  height: 69px;
  cursor: pointer;
}


.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    //font-size: 4.5rem;
    //color: #003252;
    //font-weight: 500;
    //top: 6rem;
    //position: relative;
    width: 280px;
    padding: 20px;
    img {
      width: 50%;
      line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  //height: 216px;
  overflow: hidden;
  background-color: #ffffff;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #999999;
          padding: 10px 0;
        }
        span {
          margin: 10px 10px;
          color: #999999;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {

    height: 50px;
    border-top: 1px solid #e0e0e0;
    //background: #125688;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      color: #9999a6;
      line-height: 30px;
    }
  }
}
</style>
